const DELIVERY_OPTION_TYPES = {
    SHIPPED: 'shipped',
    SAME_DAY: 'sameDay',
    PICKUP: 'pickup',
    AUTO_REPLENISH: 'autoReplenish'
};

export { DELIVERY_OPTION_TYPES };
